module.exports = __webpack_public_path__ + "static/room2-2-4fb25a591ce11b4adc7021ce17d8ecb0.jpg";